import n, { memo as k } from "react";
import { d as N, b as z, f as T, a as B, s as i, p as O, c as s, r as v, B as u, P as a, o as l, y as x } from "./javascript.esm-Cnq0KpzY.js";
import { css as r, cx as g } from "@emotion/css";
import { f as h, A as b } from "./FormErrorMessage-C4ydi9Qu-Dx-JYo5Y.js";
import { t as H } from "./CloseIcon-CiM6Hal-.js";
const I = ({
  title: e,
  titleId: o,
  ...t
}) => /* @__PURE__ */ h.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...t,
    children: [
      e ? /* @__PURE__ */ h.jsx("title", { id: o, children: e }) : null,
      /* @__PURE__ */ h.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M746.667 853.446h-448c-23.552 0-42.667-19.115-42.667-42.667s19.115-42.667 42.667-42.667h448c23.552 0 42.667 19.115 42.667 42.667s-19.115 42.667-42.667 42.667m23.082-315.208L549.376 715.945c-7.659 6.4-17.28 9.6-26.667 9.6-9.6 0-18.987-3.2-26.88-9.6L275.456 538.238c-18.347-14.72-21.099-41.6-6.4-59.947 14.72-18.347 41.6-21.333 59.968-6.4l151.019 121.813v-359.04c0-23.467 19.008-42.667 42.667-42.667 23.488 0 42.667 19.2 42.667 42.667v359.04l150.827-121.813c18.368-14.933 45.227-11.947 60.181 6.4 14.699 18.347 11.712 45.227-6.635 59.947z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), C = k(I), d = {
  wrapper: r({
    boxSizing: "border-box",
    display: "inline-flex",
    alignItems: "center",
    borderRadius: N.default,
    fontSize: z.small,
    fontFamily: T.body,
    lineHeight: 1,
    fontWeight: B.semiBold,
    maxWidth: "100%",
    "& > * + *": {
      marginLeft: i.small
    }
  }),
  icon: r({
    background: "none",
    border: "none",
    padding: 0,
    margin: 0,
    lineHeight: 1,
    textDecoration: "none",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }),
  link: r({
    cursor: "pointer",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    textDecoration: "none",
    color: "inherit"
  }),
  label: r({
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
  }),
  accessiblyHidden: r(O)
}, D = (e) => {
  const o = u(e);
  return e === "light" ? r({
    backgroundColor: o.light,
    color: s.jumbo,
    "&:hover": {
      backgroundColor: o.medium,
      color: s.jumbo
    }
  }) : r({
    backgroundColor: o.light,
    color: o.base,
    "&:hover": {
      backgroundColor: o.base,
      color: s.white,
      "& svg path": {
        fill: s.white
      }
    }
  });
}, L = (e) => {
  switch (e) {
    case "small":
      return r({
        height: v.attachmentHeightSmall,
        paddingLeft: i.default,
        paddingRight: i.small
      });
    default:
      return r({
        height: v.attachmentHeightDefault,
        paddingLeft: i.default,
        paddingRight: i.small
      });
  }
}, S = (e) => {
  switch (e) {
    case "small":
      return r({
        marginRight: i.small
      });
    default:
      return r({
        marginRight: i.default
      });
  }
}, w = (e) => e === "light" ? s.jumbo : u(e).base, y = (e) => {
  switch (e) {
    case "small":
      return 16;
    default:
      return 18;
  }
}, $ = ({ name: e, url: o, theme: t, size: c, onClear: m, className: p, onDownload: f }) => /* @__PURE__ */ n.createElement("div", { className: g(d.wrapper, p, D(t), L(c)) }, o && !m ? /* @__PURE__ */ n.createElement("a", { href: o, download: e, onClick: f, rel: "noopener noreferrer", target: "_blank", className: d.link }, /* @__PURE__ */ n.createElement("span", { className: g(d.label, S(c)) }, e), /* @__PURE__ */ n.createElement("span", { className: d.icon }, /* @__PURE__ */ n.createElement(b, { icon: C, size: y(c), color: w(t) }), /* @__PURE__ */ n.createElement("span", { className: d.accessiblyHidden }, "Download"))) : /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: g(d.label, S(c)) }, e), !!o && /* @__PURE__ */ n.createElement("a", { href: o, download: e, rel: "noopener noreferrer", target: "_blank", className: d.icon }, /* @__PURE__ */ n.createElement(b, { icon: C, size: y(c), color: w(t) }), /* @__PURE__ */ n.createElement("span", { className: d.accessiblyHidden }, "Download")), !!m && /* @__PURE__ */ n.createElement("button", { type: "button", onClick: m, className: d.icon }, /* @__PURE__ */ n.createElement(b, { icon: H, size: y(c), color: w(t) }), /* @__PURE__ */ n.createElement("span", { className: d.accessiblyHidden }, "Clear"))));
$.propTypes = {
  name: a.string.isRequired,
  url: a.string,
  theme: a.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "light", "dark", "tertiary", "info"]),
  size: a.oneOf(["", "default", "small"]),
  onClear: a.func,
  onDownload: a.func,
  className: a.string
};
$.defaultProps = {
  theme: "primary",
  size: "default"
};
const V = ({
  title: e,
  titleId: o,
  ...t
}) => /* @__PURE__ */ h.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...t,
    children: [
      e ? /* @__PURE__ */ h.jsx("title", { id: o, children: e }) : null,
      /* @__PURE__ */ h.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M860.623 813.135c0-.405.171-.768.171-1.173v-.064h-.235c-.896-19.456-2.197-38.891-5.099-58.133-2.987-19.84-7.509-39.595-15.275-58.005-6.869-16.32-16.405-31.253-28.501-43.733-13.269-13.632-29.099-24.085-45.781-32.341-21.355-10.603-44.117-17.877-66.987-23.829-14.123-3.669-28.373-6.805-42.688-9.621a1145.441 1145.441 0 0 0-23.851-4.395c-8.448-1.472-18.155-1.643-25.899-5.781-8.064-4.309-13.973-13.333-10.987-23.04 2.603-8.427 9.835-14.507 15.851-20.181 5.013-4.736 9.792-9.771 14.336-15.04 24.107-27.947 41.259-62.187 52.224-98.069 19.733-5.248 34.987-24.896 35.989-51.925.789-21.547-7.723-38.144-20.885-47.253.021-1.835.192-3.627.192-5.461 0-143.68-83.072-214.912-180.309-214.912h-.512c-96.917 0-180.309 71.232-180.309 214.912 0 1.835.149 3.627.171 5.461-13.163 9.109-21.653 25.707-20.864 47.253 1.003 27.029 16.256 46.677 35.989 51.925 10.965 35.883 28.096 70.123 52.224 98.069a195.04 195.04 0 0 0 14.336 15.04c6.016 5.675 13.227 11.755 15.829 20.181 2.987 9.707-2.923 18.731-10.987 23.04-7.723 4.139-17.429 4.309-25.877 5.781a1140.829 1140.829 0 0 0-23.872 4.395c-14.293 2.816-28.544 5.952-42.688 9.621-22.869 5.952-45.611 13.227-66.987 23.829-16.661 8.256-32.512 18.709-45.76 32.341-12.117 12.48-21.653 27.413-28.523 43.733-7.744 18.411-12.267 38.165-15.253 58.005-2.901 19.243-4.224 38.677-5.099 58.133h-.235c0 .021-.021.043-.021.064 0 .405.171.768.192 1.173-.043 1.024-.149 2.048-.192 3.093h.661c6.891 60.949 159.595 109.739 347.52 109.739 187.904 0 340.629-48.789 347.52-109.739h.64c-.043-1.045-.128-2.069-.171-3.093z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), te = k(V), P = {
  badge: r({
    flexGrow: 0,
    flexShrink: 0,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%"
  })
}, A = (e) => {
  const o = u(e);
  return r({
    backgroundColor: o.light
  });
}, M = (e) => {
  switch (e) {
    case "extraSmall":
      return r({
        width: 16,
        height: 16
      });
    case "small":
      return r({
        width: 20,
        height: 20
      });
    case "medium":
      return r({
        width: 30,
        height: 30
      });
    default:
      return r({
        width: 24,
        height: 24
      });
  }
}, F = (e) => u(e).base, W = (e) => {
  switch (e) {
    case "extraSmall":
      return 10;
    case "small":
      return 14;
    case "medium":
      return 16;
    default:
      return 14;
  }
}, j = ({ className: e, theme: o, size: t, icon: c }) => /* @__PURE__ */ n.createElement("span", { className: g(P.badge, e, A(o), M(t)) }, /* @__PURE__ */ n.createElement(b, { icon: c, size: W(t), color: F(o) }));
j.propTypes = {
  className: a.string,
  icon: a.oneOfType([a.element, a.shape({})]),
  size: a.oneOf(["", "default", "extraSmall", "small", "medium"]),
  theme: a.oneOf(["", "primary", "secondary", "success", "warning", "error", "light", "dark", "tertiary", "info", "legacy"])
};
j.defaultProps = {
  size: "default",
  theme: "primary"
};
const _ = {
  button: r({
    appearance: "none",
    borderRadius: "50%",
    border: "none",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:focus": {
      outline: "none"
    },
    "&[disabled]": {
      opacity: 0.3,
      pointerEvents: "none"
    }
  })
}, q = (e) => {
  switch (e) {
    case "extraSmall":
      return r({
        width: 16,
        height: 16
      });
    case "small":
      return r({
        width: 20,
        height: 20
      });
    case "medium":
      return r({
        width: 30,
        height: 30
      });
    default:
      return r({
        width: 24,
        height: 24
      });
  }
}, G = (e) => {
  switch (e) {
    case "extraSmall":
      return 10;
    case "small":
      return 12;
    case "medium":
      return 16;
    default:
      return 14;
  }
}, J = (e) => {
  const o = u(e);
  return r({
    backgroundColor: o.light,
    "&:hover": {
      backgroundColor: o.base,
      "& svg": {
        color: s.white
      }
    },
    "&:focus": {
      boxShadow: `0 0 2px 2px ${l(o.base, 0.3)}`,
      backgroundColor: o.base,
      "& svg": {
        color: s.white
      }
    }
  });
}, K = (e) => u(e).base, E = ({ theme: e, size: o, onClick: t, icon: c, className: m, disabled: p, ariaLabel: f, innerRef: R }) => /* @__PURE__ */ n.createElement(
  "button",
  {
    className: g(_.button, m, q(o), J(e)),
    type: "button",
    onClick: t,
    ref: R,
    disabled: p,
    "aria-label": f
  },
  /* @__PURE__ */ n.createElement(b, { icon: c, size: G(o), color: K(e) })
);
E.propTypes = {
  icon: a.oneOfType([a.element, a.shape({})]),
  size: a.oneOf(["", "default", "extraSmall", "small", "medium"]),
  theme: a.oneOf(["", "primary", "secondary", "success", "warning", "error", "light", "dark", "tertiary", "info", "legacy"]),
  onClick: a.func,
  className: a.string,
  disabled: a.bool,
  ariaLabel: a.string,
  innerRef: a.oneOfType([
    a.func,
    a.shape({
      current: a.oneOfType([a.shape({}), a.elementType])
    })
  ])
};
E.defaultProps = {
  size: "default",
  theme: "primary"
};
const oe = (e, o) => {
  const t = u(o);
  if (o === "light")
    switch (e) {
      case "outlined":
        return r({
          color: s.jumbo,
          borderColor: t.light,
          backgroundColor: "transparent",
          "&:hover": {
            backgroundColor: l(t.light, 0.3),
            boxShadow: `0 2px 4px ${l(s.black, 0.1)}`
          },
          "&:focus": {
            boxShadow: `0 0 4px 2px ${l(t.medium, 0.5)}`
          },
          "&:active": {
            backgroundColor: l(t.light, 0.6)
          }
        });
      case "dashed":
        return r({
          color: s.jumbo,
          borderColor: t.light,
          borderStyle: "dashed",
          backgroundColor: "transparent",
          "&:hover": {
            backgroundColor: l(t.light, 0.3),
            boxShadow: `0 2px 4px ${l(s.black, 0.1)}`
          },
          "&:focus": {
            boxShadow: `0 0 4px 2px ${l(t.medium, 0.5)}`
          },
          "&:active": {
            backgroundColor: l(t.light, 0.6)
          }
        });
      default:
        return r({
          color: s.jumbo,
          backgroundColor: t.light,
          "&:hover": {
            backgroundColor: l(t.medium, 0.8),
            boxShadow: `0 2px 4px ${l(s.black, 0.15)}`
          },
          "&:focus": {
            boxShadow: `0 0 4px 2px ${l(t.base, 0.5)}`
          },
          "&:active": {
            backgroundColor: t.medium
          }
        });
    }
  switch (e) {
    case "outlined":
      return r({
        color: t.base,
        borderColor: t.base,
        backgroundColor: "transparent",
        "&:hover": {
          backgroundColor: l(t.light, 0.8),
          boxShadow: `0 2px 4px ${l(s.black, 0.1)}`
        },
        "&:focus": {
          boxShadow: `0 0 4px 2px ${l(t.medium, 0.2)}`
        },
        "&:active": {
          backgroundColor: l(t.base, 0.25)
        }
      });
    case "dashed":
      return r({
        color: t.base,
        borderColor: t.base,
        borderStyle: "dashed",
        backgroundColor: "transparent",
        "&:hover": {
          backgroundColor: l(t.light, 0.8),
          boxShadow: `0 2px 4px ${l(s.black, 0.1)}`
        },
        "&:focus": {
          boxShadow: `0 0 4px 2px ${l(t.medium, 0.2)}`
        },
        "&:active": {
          backgroundColor: l(t.base, 0.25)
        }
      });
    default:
      return r({
        backgroundColor: t.base,
        "&:hover": {
          backgroundColor: t.medium,
          boxShadow: `0 2px 4px ${l(s.black, 0.1)}`
        },
        "&:focus": {
          boxShadow: `0 0 4px 2px ${l(t.medium, 0.5)}`
        },
        "&:active": {
          backgroundColor: t.dark
        }
      });
  }
}, re = (e) => {
  switch (e) {
    case "small":
      return r({
        height: 30,
        fontSize: z.small,
        padding: x([i.small, i.default])
      });
    case "medium":
      return r({
        height: 40,
        lineHeight: 1,
        padding: x([i.small, i.medium])
      });
    default:
      return r({
        height: 35,
        padding: x([i.small, i.default])
      });
  }
}, Q = ({
  title: e,
  titleId: o,
  ...t
}) => /* @__PURE__ */ h.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...t,
    children: [
      e ? /* @__PURE__ */ h.jsx("title", { id: o, children: e }) : null,
      /* @__PURE__ */ h.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M847.755 159.671v64.677h-671.48v-64.677c0-26.328 21.095-47.454 47.128-47.454h156.005V82.998c0-22.133 17.877-40.333 39.943-40.333h185.292c22.103 0 39.975 18.199 39.975 40.333v29.219h156.005c26.001 0 47.128 21.127 47.128 47.454zM715.151 844.046c0 13.455-10.921 24.376-24.376 24.376s-24.376-10.921-24.376-24.376V388.182c0-13.455 10.921-24.376 24.376-24.376s24.376 10.921 24.376 24.376zm-178.757 0c0 13.455-10.921 24.376-24.376 24.376s-24.376-10.921-24.376-24.376V388.182c0-13.455 10.921-24.376 24.376-24.376s24.376 10.921 24.376 24.376zm-178.762 0c0 13.455-10.921 24.376-24.376 24.376s-24.376-10.921-24.376-24.376V388.182c0-13.455 10.921-24.376 24.376-24.376s24.376 10.921 24.376 24.376zm485.8-567.443H176.145v657.57c0 26.032 21.095 47.159 47.128 47.159h577.454c26.032 0 47.128-21.127 47.128-47.159V281.022a4.426 4.426 0 0 0-4.422-4.422z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), ae = k(Q);
export {
  $ as A,
  E as B,
  oe as a,
  re as b,
  ae as c,
  j as d,
  te as h
};
